export default __webpack_public_path__ + "static/media/sm-localizacao.ac00a106.png";